<template>
  <ws-permission-node :resources="['services/de/mainexpert']" :actions="['create']" effect="display">
    <div class="ws-members__search ws-search-experts" v-if="exam.accred_comps.competency">
      <b-field
        class="ws-field"
        :label="$t('Поиск')"
      >
        <ws-refbook-field
          v-bind="$attrs"
          entity="refbook/experts"
          field="user_info.first.display"
          v-model="expertSearch.value"
          :guid.sync="expertSearch.guid"
          :item.sync="expertSearch.item"
          :custom-formatter="formatUserFullName"
          :placeholder="$t('Введите ФИО или электронную почту эксперта')"
          :is-clearable="false"
          :clear-on-select="true"
          :disabled="disabled"
          @change="onChange"
          :is-filter-selected="true"
          :isFocus="true"
          :query="{
            competency_guid: exam.accred_comps.competency.guid,
            with_light_certificates: true,
            'roles': roles,
          }"
          :selected="selected"
        >
          <template slot-scope="props" slot="item">
            <div class="media">
              <div class="media-left">
                <figure class="image">
                  <ws-avatar
                    v-if="props.option.user_info" :id="props.option.user_info.guid"
                    :name="`${ props.option.user_info.first.display } ${props.option.user_info.last.display}`"
                    sizeType="Small"
                    :size="48"
                  />
                </figure>
              </div>
              <div class="media-content">
              <span v-if="props.option.user_info">
                <span v-if="props.option.user_info.last.display && props.option.user_info.first.display">
                  <strong>{{ props.option.user_info.last.display }} {{ props.option.user_info.first.display }} {{ props.option.user_info.middle.display }}</strong> <br>
                  <span class="is-size-5">{{ props.option.region.title.display }}</span><br>
                  <span class="has-text-primary">{{ props.option.user_info.email }}</span>
                </span>
              </span>
                <span v-else>
                <strong>{{ props.option.email }}</strong>
              </span>
              </div>
            </div>
          </template>
          <template slot="empty">{{$t('Пользователь не найден')}}</template>
        </ws-refbook-field>
      </b-field>
    </div>
    <div class="notification is-danger" v-else>
      <p>{{$t('У экзамена не найдена профессия/специальность (ДЭ).')}}</p>
    </div>
  </ws-permission-node>
</template>

<script>
import expertTypesEnum from '../../demo-exams/data/expertTypesEnum'

export default {
  name: 'ws-experts-search',
  props: {
    change: {
      type: Function,
      default: () => {}
    },
    exam: {
      type: Object,
      default: () => ({})
    },
    expertSearch: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Array,
      default: () => []
    },
    roles: {
      type: String,
      default: () => ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange (expert) {
      this.change(expert, expertTypesEnum.expert)
    },
    formatUserFullName (user) {
      if (user.user_info) {
        return `${user.user_info.last.display} ${user.user_info.first.display} ${user.user_info.middle.display}`
      }
      return ''
    }
  }
}
</script>
